import React, { useState, useEffect } from 'react'
import AiSvg from '../Icons/AI'
import Button from '../Button/Button'
import Input from '../Input/Input'
import styles from './AiTextGenerator.module.scss'
import { generateText } from '../../api/postApi'
import cn from 'classnames'
import { useNotify } from '../../hooks/useNotify'

const AiTextGenerator = ({
  formik,
  currentInEdit,
  name,
  value,
  isInvalid,
  errorMessage,
  requestParams,
  onChange,
  maxCharacters,
  textarea = false,
  setLoading,
  loading,
}) => {
  const [isButtonVisible, setIsButtonVisible] = useState(true)
  const [placeholder, setPlaceholder] = useState('')

  const { notify } = useNotify()

  const handleGenerateText = () => {
    setLoading(true)
    getGenerateText()
  }

  const getGenerateText = async () => {
    try {
      const response = await generateText({
        ...requestParams,
        message: `${value}, the text must be not more then ${maxCharacters} characters`,
      })
      animateText(name, response.message)
      setIsButtonVisible(false)
    } catch (error) {
      notify.errorsList(error.errors)
      setLoading(false)
    }
  }

  const handleChange = (e) => {
    setIsButtonVisible(true)
    onChange(e)
    // Проверяем, если поле пустое и placeholder не установлен, запрашиваем placeholder
    if (e.target.value === '' && placeholder === '') {
      fetchPlaceholderText()
    }
  }

  const fetchPlaceholderText = async () => {
    try {
      const response = await generateText({
        ...requestParams,
        filler_name: 'field_placeholder',
        message: requestParams.filler_name,
      })
      animateTextPlaceholder(response.message)
    } catch (error) {
      notify.errorsList(error.errors)
      return 'You can generate text by yourself or by Ai'
    }
  }

  const animateTextPlaceholder = (text) => {
    let index = 0
    const typingInterval = setInterval(() => {
      setPlaceholder((prev) => prev + text[index])
      index++
      if (index === text.length) {
        clearInterval(typingInterval)
      }
    }, 50)
  }

  const animateText = (name, text) => {
    let index = 0
    const typingInterval = setInterval(() => {
      formik.setValues({
        ...formik.values,
        [name]: text.slice(0, index + 1),
      })
      index++
      if (index === text.length) {
        clearInterval(typingInterval)
        setLoading(false)
      }
    }, 20)
  }

  useEffect(() => {
    setPlaceholder('')
  }, [requestParams])

  useEffect(() => {
    setIsButtonVisible(true)
  }, [currentInEdit])

  return (
    <div className={styles.textGenerator}>
      <Input
        name={name}
        textarea={textarea}
        value={value}
        onChange={handleChange}
        className={cn(styles.textArea, {
          [styles.textArea_withAiButton]: isButtonVisible,
        })}
        isInvalid={isInvalid}
        errorMessage={errorMessage}
        onFocus={(e) => {
          if (!value && (!placeholder || placeholder === '')) fetchPlaceholderText(e)
        }}
      />
      {!value && <span className={styles.placeholder}>{placeholder}</span>}
      <Button
        type="button"
        onClick={handleGenerateText}
        disabled={!value || !isButtonVisible || loading}
        className={cn(styles.generateButton, {
          [styles.generateButtonHidden]: !isButtonVisible,
          [styles.aiSvgLoading]: loading,
        })}
      >
        <AiSvg width={22} height={22} fill="#E7B92A" />
      </Button>
    </div>
  )
}

export default AiTextGenerator
